export default "__VITE_ASSET__C49xQ0wC__"